// @ts-check

import { URL_GET_USER_INFO } from 'constants/urls';

/**
 * @async
 * @function getUserInfoApi
 * @returns {Promise<UserInfoDataType>}
 * @throws {Error}
 */
async function getUserInfoApi() {
	const options = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	};

	const res = await fetch(URL_GET_USER_INFO, options);

	if (!res.ok) {
		const message = `HTTP error! status: ${res.status}`;
		throw new Error(message);
	} else {
		const data = await res.json();
		return data;
	}
}

export default getUserInfoApi;
